// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { isMonday as fn } from "../isMonday.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const isMonday = convertToFP(fn, 1);

// Fallback for modularized imports:
export default isMonday;
